export const DpInterestDetailsMapper = (response) => {
    if (response)
        return response.map((x) => {
            return {
                transactionDate: x.transactionDate,
                runningAmount: x.runningAmount,
                days: x.days,
                interestAmount: x.interestAmount,
                interestRate: x.interestRate,
                isMTF: x.isMTF,
            };
        });
    return [];
};
